<template>
  <section class="fill-width fill-height">
    <template v-if="resultData.contentList.length > 0">
      <div class="mb-10">
        <LoadImage contain
                   :src="$downUrl(resultData.dlgtImgAtchFileName)" />
        <div class="fs-18 fw-500 pa-5">{{ resultData.title }}</div>
        <v-divider />
        <div class="pa-5 " v-html="content"></div>
      </div>
    </template>
    <template v-else>
      <slot name="no-data">
        <NoData />
      </slot>
    </template>
  </section>
</template>

<script>
export default {
  props: {
    resultData: {
      type: Object,
      default: () => ({
        title: null,
        dlgtImgAtchFileName: null,
        contentList: []
      })
    }
  },
  computed: {
    content () {
      return this.resultData.contentList[0].content
    }
  }
}
</script>
